var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{staticClass:"smart-address",attrs:{"data-type":"default"}},[_c('a',{on:{"click":_vm.handleAddressClick}},[_c('p',[_vm._v(_vm._s(_vm.address.address1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.address.address2))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2525a87c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmartAddress.vue
// module id = mZo6
// module chunks = 1